<template>
  <v-container>
    <h2>
      お申込みの流れ
    </h2>
    <br>
    <p>
      OilMatrixを利用して分析・診断のお申込みいただく際は、下記のお申込みの流れをご確認ください。
    </p>
    <v-timeline dense>
      <v-timeline-item v-for="(item, i) of flow" v-bind:key="i"  fill-dot small>
        <v-card class="pa-2">
          <div class="title">{{item.title}}</div>
          <v-row dense>
            <v-col dense cols="4" md="2">
              <img :src="item.img" style="max-width:100%">
            </v-col>
            <v-col dense cols="8" md="10">
              <span class="body-2" v-html="item.body"></span>
            </v-col>
          </v-row>
          <v-divider v-show="item.link" class="my-4"></v-divider>
          <div align="center" v-for="(lnk,i ) in item.link" v-bind:key="i" class="my-1">
            <v-btn v-show="lnk.linkName" small class="white--text" color="success" @click="showMan(lnk.id)">
              「{{lnk.linkName}}」マニュアルを見る
            </v-btn>
          </div>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </v-container>
</template>
<script>
export default {
    data: () => ({
        buttonName: '',
        flow:[
          { 
            title: '１． マイ機器登録',
            body: '最初に採油対象の機器を登録してください（マイ機器の登録）<br>マイ機器を登録していただくと、システムから採油登録画面のURLがセットされたQRコードを発行します。<br>QRコードを機器等に貼り付けていただくとスマートフォン等からQRコードを読み取ることで、簡単に採油登録画面にアクセスすることができるようになります。<br>マイ機器登録、マイ機器QRコードについては下記のマニュアルをご覧ください。',
            img: '/img/qr.png',
            link:[ {id:'manMyMachineEdit', linkName:'マイ機器の登録/更新/削除'},{id:'manMyMachineQrPrint', linkName:'マイ機器QRコードを印刷する'} ] 
          },
          { 
            title: '２． 採取サンプル登録',
            body: '機器から採取したサンプル情報を「分析サンプルの採取登録」画面より登録してください。この登録画面では分析区分や分析項目、フィルター返却の要否等の分析内容と、分析料金が確認できます。<br>サンプルの登録については「分析サンプルを採取登録する」のマニュアルをご覧ください。',
            img: '/img/harvesting.png',
            link: [{ id:'manSampleEntry', linkName:'分析サンプルを採取登録する',}]
          },
          { 
            title: '３． お申込み',
            body: 'お申込みフォームから、分析を依頼してください。<br>お申込みフォームでは報告書や請求書の宛先・送付先を指定します。<br>また、送付するサンプルについて採取済のサンプルリストから選択してください。<br>お申込みフォームについては「分析を依頼する」のマニュアルをご覧ください。',
            img: '/img/request.png',
            link: [{id:'manAnalizeEntry', linkName:'分析を依頼する', }]
          },
          { 
            title: '４． 書類の印刷',
            body: '各種お申込み用の書類を印刷してください。<br>印刷するものは「お申込み書」と「サンプル貼り付け用バーコード」の２種類です。サンプル貼り付け用バーコードは分析対象のサンプルボトルに貼り付けてください。<br>お申込書のサンプル貼り付け用バーコードについては下記のマニュアルをご覧ください。',
            img: '/img/print.png',
            link:[ {id:'manEntryPrint', linkName:'申し込み書を印刷する'},{id:'manSampleQrPrint', linkName:'分析サンプル貼り付け用バーコードシートを印刷する'} ] 
          },
          { 
            title: '５． 梱包',
            body: '送付する箱の中に、印刷したお申込書とバーコードを貼り付けたサンプルボトルを入れ、梱包してください。',
            img: '/img/boxing.png',
          },
          { 
            title: '６． 発送',
            body: '梱包した箱を弊社まで発送ください。',
            img: '/img/shipping.png',
          },

        ]
    }),
    methods: {
      showMan: async function(value) {
        var url = '/UserManual/' + value
        this.$router.push(url)        
      }
    }
}
</script>

